import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { getImageLocal } from '@/utils/locals';
import EFArrowDown from '@/components/UI/svg/Icons/EFArrowDown';
import EFVideo from '@/components/UI/EFVideo';
import { createEFPic } from '@/utils/useEFPic';
import AppPointRiverAdv from '@/components/AppPoint/RiverAdvPC';
import { SHOW_APP_POINT_SITES } from '@/constants';

const { EFPic } = createEFPic('/media/river2/pc/');
export default function K() {
    const { useLang, useRouter, Link } = useGlobal();
    const { t } = useLang('productriver2');
    const { locale } = useRouter();
    const appLocal = getImageLocal(locale, ['cn', 'de', 'es', 'fr', 'it', 'jp', 'kr', 'nl', 'cis']);
    const appRedirect = ['us', 'ca', 'uk', 'au', 'de', 'fr', 'jp', 'cn', 'mx'];

    return (
        <div className={`${css.K_11} river2_detials_K`}>
            {!SHOW_APP_POINT_SITES.includes(locale) && (
                <div className="innerBox">
                    <div className="controlBox">
                        <div className="title">{t('river2.details.sec11_title')}</div>
                        <div className="EFLogo">
                            <EFPic name={['logo.webp', 'logo.png']} alt={t('river2.details.sec11_title')} aria-label={t('river2.details.sec11_title')} />
                        </div>
                        <div className="app">{t('river2.details.sec11_app')}</div>
                        <div className="desc">{t('river2.details.sec11_text')}</div>
                        {appRedirect.includes(locale) && (
                            <Link href="/app" className="link_learn" newWin>
                                <div className="text2">{t('river2.learn_more')}</div>
                                <div className="icon">
                                    <EFArrowDown
                                        style={{
                                            fontSize: '17px',
                                            marginTop: '6px',
                                            transform: 'rotate(-90deg)',
                                        }}
                                    />
                                </div>
                            </Link>
                        )}
                    </div>
                    <div className="videoLists">
                        <div className="videoLeft videoItem">
                            <EFVideo
                                sources={[`/video/river2/details/11_1.webm`, `/video/river2/details/11_1.mp4`]}
                                className="fullImgs"
                                width="545px"
                                height="680px"
                                poster={'/media/river2/pc/11_1.jpg'}
                            />
                            <p className="list_text">{t('river2.details.sec11_list1')}</p>
                        </div>
                        <div className="videoRight videoItem">
                            <EFVideo
                                sources={[`/video/river2/details/11_2_${appLocal}.webm`, `/video/river2/details/11_2_${appLocal}.mp4`]}
                                className="fullImgs"
                                width="545px"
                                height="680px"
                                poster={'/media/river2/pc/11_2.jpg'}
                            />
                            <p className="list_text">{t('river2.details.sec11_list2')}</p>
                        </div>
                    </div>
                </div>
            )}
            {SHOW_APP_POINT_SITES.includes(locale) && <AppPointRiverAdv local={locale} />}
        </div>
    );
}
